import { COLORS } from '@btime/constants'
import { FilterHandler } from '@btime/react-contexts'
import React from 'react'

import { HorizontalLine } from '../../../components/shapes/Line'
import ControlledModal from '../../../components/modals/ControlledModal'
import ModalHeader from './ModalHeader'
import Separator from '../../../components/helpers/Separator'
import TemplatesLoader from './_load/TemplatesLoader'
import TemplatesTable from './table/TemplatesTable'

const TemplatesModal = props => {
  return (
    <ControlledModal width="64rem" {...props}>
      <FilterHandler tempStorageNamespace="templates" initialState={{}}>
        <TemplatesLoader>
          <ModalHeader />

          <HorizontalLine thin lineColor={COLORS.light2} />
          <Separator weight={2} />

          <TemplatesTable />

          <Separator weight={5} />
        </TemplatesLoader>
      </FilterHandler>
    </ControlledModal>
  )
}

export default TemplatesModal
